import { createMutation, toast, useLocalization } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { auth } from '~/config/auth';
import { createMagicDoorContext } from '~/contexts/utils';
import type { CompanyOptionDto, OtpAuthDto } from '@magicdoorinc/auth';
import type { SendOtpDto } from '~/swagger/portal/Api';

export enum OtpLoginStep {
  InputPhone = 'InputPhone',
  SelectCompany = 'SelectCompany',
  InputVerifyCode = 'InputVerifyCode',
}

export const [OtpLoginProvider, useOtpLogin] = createMagicDoorContext('OtpLogin', () => {
  const [loginStep, setLoginStep] = createSignal<OtpLoginStep>(OtpLoginStep.InputPhone);
  const [companies, setCompanies] = createSignal<CompanyOptionDto[]>([]);
  const [requestId, setRequestId] = createSignal<string | undefined>(undefined);
  const { t } = useLocalization();

  const sendOtp = createMutation(async (data: SendOtpDto) => {
    const result = await auth.sendOTP(data);
    setRequestId(result.requestId);
    if (result.companies?.length) {
      setLoginStep(OtpLoginStep.SelectCompany);
      setCompanies(result.companies);
    } else {
      setLoginStep(OtpLoginStep.InputVerifyCode);
    }
    return result;
  });

  const verifyOtp = createMutation(async (data: OtpAuthDto) => {
    try {
      const result = await auth.verifyOTP(data);

      if (result.interactionCode) {
        await auth.initiateOAuthFlow(result.interactionCode);

        return result;
      }

      return result;
    } catch {
      toast.error(t('{name} is invalid', { name: t('Verify code') }));
    }
  });

  return {
    loginStep,
    setLoginStep,
    sendOtp,
    verifyOtp,
    companies,
    requestId,
  };
});
